var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style[("root--" + _vm.type)]] = _vm.type, _obj )],attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[(_vm.ico)?_c('Ico',{class:_vm.$style.ico,attrs:{"name":_vm.ico}}):_vm._e(),(_vm.label)?_c('span',{class:_vm.$style.label},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4971e982","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/objects/Anchor/index.vue
// module id = hzk9
// module chunks = 2